/* RESPONSIBLE TEAM: team-proactive-support */
import BaseSalesRoute from 'embercom/routes/apps/app/reports/base/sales-route';

export default BaseSalesRoute.extend({
  parentRoute: 'apps.app.reports.lead-generation.sales',
});
